const messages = {
  title: "Consentimientos de marketing",
  required: "Obligatorio",
  answered: "✓ Respondido",
  read: "Leído",
  notRead: "No leído",
  alreadyAnswered: "Ya respondido",
  requiredQuestionsMustBeAccepted:
    "Debe aceptar {count} pregunta(s) obligatoria(s)",
  pleaseAnswerQuestions: "Responda a las siguientes preguntas:",
  iAccept: "Acepto",
  scrollToUnlock: "Desplácese hasta el final para desbloquear",
  fieldRequired: "Este campo es obligatorio",
  scrollToContinue: "↓ Desplácese hasta el final para continuar",
  saving: "Guardando...",
  saveConsents: "Guardar consentimientos",
  allRequiredAccepted: "✓ Todas las preguntas obligatorias aceptadas",
  requiredConsentsCompleted:
    "{completed}/{total} consentimientos obligatorios completados",
  selectConsentToView:
    "Seleccione un consentimiento de la lista para ver su contenido",
  readAllContentFirst: "Lea primero todo el contenido: {names}",
  acceptAllRequiredIn:
    "Acepte todas las preguntas obligatorias en: {names}",
  acceptAllBeforeSaving:
    "Acepte todas las preguntas obligatorias antes de guardar.",
  failedToSave:
    "No se pudieron guardar los consentimientos. Inténtelo de nuevo.",
  errorSaving:
    "Se produjo un error al guardar los consentimientos. Inténtelo de nuevo.",
  failedToLoad:
    "No se pudieron cargar los consentimientos. Actualice la página.",
  viewPdf: "Ver PDF",
  requiredConsentTitle: "Consentimiento obligatorio",
  acceptAndContinue: "Aceptar y continuar",
};

export default {
  messages,
};
